import React from 'react';

function PlusSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        d="M14.857 6.857H9.143V1.143a1.143 1.143 0 00-2.286 0v5.714H1.143a1.143 1.143 0 000 2.286h5.714v5.714a1.143 1.143 0 002.286 0V9.143h5.714a1.143 1.143 0 000-2.286z"
      ></path>
    </svg>
  );
}

export default PlusSvg;
